export default __webpack_public_path__ + "static/media/getintogear.9da51add.png";